import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `
    <svg
      width="50"
      height="50"
      viewBox="0 0 473 554"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      [attr.class]="className"
    >
      <rect width="473" height="554" fill="url(#pattern0_718_6703)" />
      <defs>
        <pattern
          id="pattern0_718_6703"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlink:href="#image0_718_6703"
            transform="scale(0.00211416 0.00180505)"
          />
        </pattern>
        <image
          id="image0_718_6703"
          width="473"
          height="554"
          xlink:href="icons/logo.svg"
        />
      </defs>
    </svg>
  `,
})
export class LogoComponent {
  @Input() className?: string;
}